export const BREEDLOG_LIST_REQUEST = 'BREEDLOG_LIST_REQUEST';

export const BREEDLOG_LIST = 'BREEDLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_BREEDLOG_PAGINATION = 'SET_BREEDLOG_PAGINATION';

export const BREEDLOG_PAGE_RESET = 'BREEDLOG_PAGE_RESET';
